import Plyr from "plyr";

const AudioWidget = () => {
	const block = document.querySelector(".audio-widget");
	if (!block) {
		return;
	}

	const players = Plyr.setup(document.querySelectorAll(".audio-widget audio"), {
		controls: [
      "play",
      "progress",
      "current-time",
      "mute",
      // "volume"
    ],
    // speed: {
    //   selected: 1,
    //   options: [1, 2, 3]
    // }
		// settings: []
	});

	players.forEach(player => {
		player.on("play", () => {
			const others = players.filter(other => other != player);

			// pause other audios
			document.querySelectorAll("audio").forEach(item => {
				if (!item.closest(".audio-widget")) {
					item.pause();
				}
			});

			others.forEach(other => {
				other.pause();
			});
		});
	});
};


export default AudioWidget;